<template>
    <van-sticky :offset-top="40" id="music-play">
        <div class="imgcontainer">
            <van-image
                round
                width="3rem"
                height="3rem"
                rel="external nofollow"
                class="music-act"
                :src="'https://public.qiniu.xcims.com/' + (playing ? 'wx_shopactmusic.gif' : 'wx_shopactmusicstop.png')"
                @click="onMusic('cheerMusic')"
            />
            <audio
                id="cheerMusic"
                ref="music"
                preload="auto"
                loop="loop"
                src="https://public.qiniu.xcims.com/wx_shopact.mp3"
                ></audio>
        </div>
    </van-sticky>
</template>

<script>
import { 
    Icon,
    Image,
    Sticky
} from 'vant'

import { WxShopActMusicUrl } from '@/api/assert'

export default {
    name: 'MusicPlay',
    components: {
        [Icon.name]: Icon,
        [Image.name]:Image,
        [Sticky.name]: Sticky
    },

    mounted: function() {
        this.audioAutoPlay("cheerMusic");
    },
    data() {
        return {
            musicUrl: WxShopActMusicUrl,
            playing: true
        }
    },
    methods: {
        onMusic(id) {
            var audio=document.getElementById(id);
            if (this.playing) {
                console.log('onMusic_ready_pause')
                console.log(this.playing)
                audio.pause()
                audio.load()
                this.playing = false
                document.addEventListener("WeixinJSBridgeReady",function() {
                    audio.pause()
                },false)
                document.addEventListener("YixinJSBridgeReady",function() {
                    audio.pause()
                },false)
                
            } else {
                console.log('onMusic_ready_play')
                this.audioAutoPlay("cheerMusic");
                // audio.play()
                // audio.load()
                this.playing = true
            }
            
            // if (this.playing) {
            //     this.$refs.MusicPlay.pause()
            //     this.playing = false
            // } else {
            //     this.$refs.MusicPlay.play()
            //     this.playing = true
            // }
        },
        audioAutoPlay(id) {
            try {
                var audio=document.getElementById(id);
                audio.play();
                document.addEventListener("WeixinJSBridgeReady",function() {
                    audio.play()
                },false)
                document.addEventListener("YixinJSBridgeReady",function() {
                    audio.play()
                },false)
                this.playing = true
            } catch {
                console.log('music error')
            }
        }
    }
}
</script>

<style lang="less">
#music-play {
    height: 0;

    .imgcontainer {
        margin-left: 2em;

        .music-act {
            margin: 0.5em;
            background-color: #0066CC;
        }
        .music-stc {
            margin: 0.5em;
            background-color: #CCCCCC;
        }
    }
}
</style>
